import styles from './ProfileCard.module.scss';
import { withRouter } from 'react-router-dom';
import IGenericResult from '../../interfaces/IGenericResult';
// import { ILatLng } from '../map/Map';
// import axios from 'axios';
import { useState } from 'react';
// import { getCurrentPosition } from '../../lib/util';
import GenericButton from '../generic-button/GenericButton';
import { ProfileIcon } from '../icons/Icons';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import CheckIcon from '@mui/icons-material/Check';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

const ProfileCard = (props: any) => {
  const { recordId, name, specialty, specialties, phone, addressLine1, addressLine2, city, state, zipCode, acceptingNewPatients, approximateDistance } = props.result as IGenericResult;
  // const [directions, setDirections] = useState<google.maps.DirectionsResult>();
  const [miles, setMiles] = useState(approximateDistance);

  // useEffect(() => {
  //   getDistanceForProfile(addressLine1, addressLine2, setMiles, setDirections);
  // }, [addressLine1, addressLine2]);
  const specialtyList = specialties;
  const handleProfileClick = (passedProps: any) => {
    const { planCode, directory } = passedProps.match.params;
    passedProps.history.push(`/profile/${planCode}/${recordId}/${directory}`);
  };

  return (
    <div className={styles.profileCard}>
      <div className="flex justify-between flex-col flex-row-desktop">
        <div>
          <p className={styles.name}>{name}</p>
          {specialties
            ? specialties.map((spec, i) => (
                <p key={spec.specialtyName} className={styles.specialty}>
                  {spec.specialtyName}
                </p>
              ))
            : null}
          <p className={styles.subInformation}>{addressLine1}</p>
          {addressLine2 ? <p className={styles.subInformation}>{addressLine2}</p> : null}
          <p className={styles.subInformation}>
            {city}, {state} {zipCode}
          </p>
        </div>
        <div>
          {miles && (
            <div className={styles.approximateDistance}>
              <p className={styles.location}>
                <LocationOnOutlinedIcon style={{ color: '#1DAA51', marginRight: 10 }} /> {approximateDistance} mi
              </p>
            </div>
          )}
          {acceptingNewPatients && (
            <p className={styles.location}>
              <CheckIcon style={{ color: '#1DAA51', marginRight: 10 }} /> Accepting New Patients
            </p>
          )}
          {phone && (
            <p className={styles.phone}>
              <LocalPhoneIcon style={{ color: '#1DAA51', marginRight: 10 }} /> {phone}
            </p>
          )}
        </div>
        {/* <p>{typeof acceptingNewPatients === 'undefined' ? '' : `Accepting New Patients: ${acceptingNewPatients}`}</p> */}
      </div>

      <div className={styles.cardButtonContainer} style={{ marginTop: 15 }}>
        <GenericButton buttonText={'View Profile'} handleClick={() => handleProfileClick(props)}>
          <ProfileIcon />
        </GenericButton>
        {/* <GenericButton buttonText={'Get Directions'} handleClick={() => props.handleDirections(directions)}>
          <MapMarkerIcon />
        </GenericButton> */}
        <p>Click profile for more information and to Get Directions.</p>
      </div>
    </div>
  );
};

// TODO: Remove this
// const getDistanceForProfile = (
//   address1: string,
//   address2: string,
//   setMiles: React.Dispatch<React.SetStateAction<string>>,
//   setDirections: React.Dispatch<React.SetStateAction<google.maps.DirectionsResult | undefined>>
// ) => {
//   (async () => {
//     try {
//       let currentLocation = { lat: 0, lng: 0 };
//       const res: any = await getCurrentPosition();
//       const { latitude, longitude } = res.coords;
//       currentLocation.lat = latitude;
//       currentLocation.lng = longitude;
//       let distance: string = 'N/A';
//       if (process.env.REACT_APP_MAPS_API_KEY) {
//         const formattedAddress = `${address1} ${address2}`.split(' ').join('+');
//         const geocode = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${formattedAddress}&key=${process.env.REACT_APP_MAPS_API_KEY}`);
//         if (geocode.data.results.length > 0) {
//           const locationToMark: { lat: number; lng: number } = geocode.data.results[0].geometry.location;
//           getDirections(currentLocation, locationToMark, setDirections);
//           distance = getDistance(currentLocation, locationToMark);
//         }
//       }
//       // setMiles(distance);
//     } catch (err) {
//       console.error(err);
//     }
//   })();
// };

// const rad = (x: number) => {
//   return (x * Math.PI) / 180;
// };

// const getMiles = (meters: number) => {
//   return (meters * 0.000621371192).toFixed(2);
// };

// const getDistance = (p1: ILatLng, p2: ILatLng): string => {
//   var R = 6378137; // Earth’s mean radius in meter
//   var dLat = rad(p2.lat - p1.lat);
//   var dLong = rad(p2.lng - p1.lng);
//   var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
//   var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   var d = R * c;
//   return getMiles(d); // returns the distance in meter
// };

// const getDirections = (origin: any, destination: any, setDirections: React.Dispatch<React.SetStateAction<google.maps.DirectionsResult | undefined>>) => {
//   const DirectionsService = new google.maps.DirectionsService();

//   DirectionsService.route(
//     {
//       origin: new google.maps.LatLng(origin.lat, origin.lng),
//       destination: new google.maps.LatLng(destination.lat, destination.lng),
//       travelMode: google.maps.TravelMode.DRIVING
//     },
//     (result, status) => {
//       if (status === google.maps.DirectionsStatus.OK) {
//         if (result) {
//           setDirections(result);
//         }
//       } else {
//         console.error(`error fetching directions ${result}`);
//         return {
//           geocoded_waypoints: [],
//           routes: []
//         };
//       }
//     }
//   );
// };

export default withRouter(ProfileCard);
